var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-XLvideo"},[_c('video',{attrs:{"id":"myVideo","preload":"auto","loop":"","playsinline":"","autoplay":"","src":require("../style/mp4/picture2.mp4"),"tabindex":"-1","muted":"muted"},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }